import { render } from "./SitePlayground.vue?vue&type=template&id=e8f8f77a&ts=true"
import script from "./SitePlayground.vue?vue&type=script&lang=ts"
export * from "./SitePlayground.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__